
export default function About() {
  return (
    <section id="about" className="py-24 px-6 bg-gradient-to-b from-black via-gray-900 to-black">
      <div className="max-w-6xl mx-auto">
        <div className="grid md:grid-cols-2 gap-16 items-center">
          {/* Left Column - Text */}
          <div>
            <h2 className="text-5xl md:text-6xl font-bold text-white mb-8 leading-tight">
              About Me
            </h2>
            <div className="space-y-6 text-gray-300 text-lg leading-relaxed">
              <p>
                I study Film and Television Production at Högskolan Dalarna, working across both film and television formats.
              </p>
              <p>
                My primary focus is post-production, shaping edits with precision in narrative clarity, pacing, and emotion.
              </p>
            </div>
          </div>

          {/* Right Column - Profile Image */}
          <div className="relative">
            <div className="relative aspect-[3/4] rounded-lg overflow-hidden">
              {/* Gradient Border Effect */}
              <div className="absolute -inset-1 bg-gradient-to-br from-teal-500/30 via-pink-500/30 to-teal-500/30 rounded-lg blur-xl"></div>
              
              {/* Profile Image */}
              <div className="relative w-full h-full bg-gray-900 rounded-lg overflow-hidden">
                <img
                  src="https://static.readdy.ai/image/1f9220bbbe9ef28e4ff27eb731024602/3bfa114659f73a92ef7718fb922fa0e4.png"
                  alt="Omar Mohamed"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
